export const companyName = "Apsis"
export const realName = "CLOUD AUTOMATION SERVICOS EM TECNOLOGIA DA INFORMACAO LTDA"
export const address = "Rua Pinheiro Machado, 550/804"
export const location = "Centro"
export const city = "Lajeado/RS"
export const country = "Brasil"
export const phone = "+5551999727599"
export const formatedPhone = `${phone.slice(0,3)} (${phone.slice(3,5)}) ${phone.slice(5,6)} ${phone.slice(6,10)}-${phone.slice(10)}`
export const email = "contato@apsis.cc"
export const year = new Date().getFullYear()
export const cnpj = "30.037.165/0001-07"
